/**
 * Transforme les settings json en objet
 * @param {string} idSettings L'identifiant pour retrouver le json dans le DOM
 * @return {{}|any} Les settings
 */
function loadJsonSetings(idSettings) {
  const settingsElement = document.querySelector(
    "body > script[type='application/json'][data-8ab-settings='" + idSettings + "']",
  );

  if (settingsElement !== null) {
    return JSON.parse(settingsElement.textContent);
  }

  return {};
}

/**
 * Les settings pour le portail colloc.
 * @type {Appconfig}
 */
let huitabSettings = loadJsonSetings('8ab-settings-json');

huitabSettings.iframes.default_min_height = Number(huitabSettings.iframes.default_min_height);
huitabSettings.tache_refresh_interval = Number(huitabSettings.tache_refresh_interval);
huitabSettings.avatar.enabled = huitabSettings.avatar.enabled === 'true';
// Cast en booleen des valeurs de feature flipping inscrites en string dans les inventaires
for (const [feature, valeur] of Object.entries(huitabSettings.feature_flipping)) {
  huitabSettings.feature_flipping[feature] = valeur === 'true';
}

// transformer date cgu en Date
let dateParts = huitabSettings.last_cgu_update.split('/');
huitabSettings.last_cgu_update = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
console.log('SETTINGS_CGU: ' + huitabSettings.last_cgu_update);

/**
 * Les settings pour le portail colloc.
 * @type {MasterpageConfig}
 */
const huitabMasterpageSettings = loadJsonSetings('8ab-masterpagesettings-json');

for (const setting in huitabMasterpageSettings) {
  if (huitabMasterpageSettings[setting].microapp && huitabMasterpageSettings[setting].microapp.iframeMinHeight) {
    huitabMasterpageSettings[setting].microapp.iframeMinHeight = Number(
      huitabMasterpageSettings[setting]?.microapp.iframeMinHeight,
    );
  }
}

// Active les URLs V2 si la feature 'interlocuteurs_prevenance' est activée.
if (huitabSettings.feature_flipping.interlocuteurs_prevenance) {
  huitabMasterpageSettings.INTERLOCUTEURS_COUPURES.microapp.url = huitabSettings.url.consulter_interlocuteurs_v2_url;
  huitabMasterpageSettings.GESTION_INTERLOCUTEURS_EN_MASSE.microapp.url = huitabSettings.url.gestion_interlocuteurs_en_masse_v2_url;
}

export { huitabSettings, huitabMasterpageSettings as PageTypes };
